import * as types from './types';

export const updateUserActionRequest = (data) => ({ type: types.UPDATE_USER_ACTION_REQUEST, data });
export const updateUserActionRequestFailure = (error) => ({ type: types.UPDATE_USER_ACTION_REQUEST_FAILURE, error });
export const updateUserActionRequestSuccess = (data) => ({ type: types.UPDATE_USER_ACTION_REQUEST_SUCCESS, data });
